export enum CustomerSynchronizedStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  NOT_SYNCHRONIZED = 'NOT_SYNCHRONIZED',
  PROCESSING = 'PROCESSING',
}

export enum SubmitOperations {
  CREATE = 'CREATE',
  ACCEPT_IGNORED = 'ACCEPT_IGNORED',
  ACCEPT_SUGGESTION = 'ACCEPT_SUGGESTION',
}

export enum CustomerOriginType {
  INTEGRATION = 'INTEGRATION',
  MANUAL = 'MANUAL',
  SPREADSHEET_IMPORT = 'SPREADSHEET_IMPORT',
  EXTERNAL_FORM = 'EXTERNAL_FORM',
  CONNECTION = 'CONNECTION',
}

export enum CustomerMediaUsage {
  COMMON_MEDIAS = 'medias',
  INTERNAL_EXTERNAL_PHOTOS = 'internal_external_photos',
}

export enum UnconvertedCustomerFilter {
  NEVER_ORDERED = 'NEVER_ORDERED',
  ABANDONED_LAST_ORDER = 'ABANDONED_LAST_ORDER',
}
